import { useEffect, useRef } from "react";
import "./evolve.scss";
import useDetailPage from "../../../hooks/useDetailPage";
import { CAT_NAME } from "../../../utils/constant";
import { Link } from "react-router-dom";
import ResponsiveImage from "../../common/ResponsiveImage";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const Evolve = () => {
  const { posts, loading, singleBlog } = useDetailPage({ blogCount: 3 });

  const sectionRef = useRef(null);

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll(".animate");

    elements.forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 400 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 120%", // Start animation when 80% of the element is in view
            toggleActions: "play reverse play reverse", // Repeat animation on scroll
          },
        }
      );
    });
  }, []);

  const sectionRef1 = useRef(null);

  useEffect(() => {
    const elements = sectionRef1.current.querySelectorAll(".animate");

    elements.forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 400 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%", // Start animation when 80% of the element is in view
            toggleActions: "play reverse play reverse", // Repeat animation on scroll
            markers: false
          },
        }
      );
    });
  }, []);


  return (
    <>
      <section className="evolvemain">
        <div className="custom-container" ref={sectionRef} >
          <div className="evolvetop">
            <h4 className="evolvehead animate">Evolve with TOMI</h4>
            {/* <button className="seebtn">See All</button> */}
            <Link className="seebtn animate" to="/blog">See All</Link>
          </div>
          <div className="animate">
            {posts.length > 0 ? (
              <div className="evolvecardmain">
                {posts.map((post) => (
                  <div onClick={() => singleBlog(post.slug)} key={post.id} className="evolvecard">
                    <div className="evolvecardimg">
                      <ResponsiveImage post={post} className='innerimg' />
                    </div>
                    <span className="innerspan ">{CAT_NAME[post.categories?.[0]]}</span>
                    <h4 className="evolvecardhead" dangerouslySetInnerHTML={{ __html: post?.title?.rendered }} />
                  </div>
                )
                )}
              </div>

            ) : (
              !loading && <p className="text-center pb-5">No Posts Available.</p>
            )}
          </div>
        </div>
      </section>

      <section className="lastsection">
        <img src="/assets/roadmapassets/banner/lastsection.png" alt="lastsectionimg" className="lastsectionimg" />
        <img src="/assets/roadmapassets/banner/lastsectionmbl.png" alt="lastsectionimg" className="lastsectionimgmbl d-none" />
        <div className="custom-container">
          <div className="lastmaincards" ref={sectionRef1}>
            <Link to='/whitepaper' className="lastcard animate">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
              >
                <path
                  d="M22.3747 17.75H15.083"
                  stroke="#FF0083"
                  stroke-width="1.75"
                  stroke-linecap="square"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.3747 11.9167H15.083"
                  stroke="#FF0083"
                  stroke-width="1.75"
                  stroke-linecap="square"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.33301 3.75C5.84976 3.75 5.45801 4.14175 5.45801 4.625C5.45801 5.10825 5.84976 5.5 6.33301 5.5H25.2913C25.8328 5.5 26.3521 5.7151 26.735 6.09799C27.1179 6.48088 27.333 7.00018 27.333 7.54167V11.7543L29.083 10.7439V7.54167C29.083 6.53605 28.6835 5.57163 27.9725 4.86055C27.2614 4.14948 26.297 3.75 25.2913 3.75H6.33301ZM29.083 14.0321L27.333 15.0425V25.0417C27.333 25.5249 27.7248 25.9167 28.208 25.9167C28.6913 25.9167 29.083 25.5249 29.083 25.0417V14.0321Z"
                  fill="#FF0083"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.33366 3.75C5.32805 3.75 4.36362 4.14948 3.65255 4.86055C2.94147 5.57163 2.54199 6.53605 2.54199 7.54167V10.4583C2.54199 11.0772 2.78782 11.6707 3.22541 12.1082C3.66299 12.5458 4.25649 12.7917 4.87533 12.7917H8.37533V22.7002L10.1253 21.6898V11.9167V7.54167C10.1253 6.53605 9.72585 5.57163 9.01477 4.86055C8.3037 4.14948 7.33927 3.75 6.33366 3.75ZM10.1253 24.978L8.37533 25.9884V27.9583C8.37533 28.9639 8.7748 29.9284 9.48588 30.6394C10.197 31.3505 11.1614 31.75 12.167 31.75H29.667C30.6726 31.75 31.637 31.3505 32.3481 30.6394C33.0592 29.9284 33.4587 28.9639 33.4587 27.9583V26.5C33.4587 25.8812 33.2128 25.2877 32.7752 24.8501C32.3377 24.4125 31.7442 24.1667 31.1253 24.1667H16.542C15.9232 24.1667 15.3297 24.4125 14.8921 24.8501C14.4545 25.2877 14.2087 25.8812 14.2087 26.5V27.9583C14.2087 28.4998 13.9936 29.0191 13.6107 29.402C13.2278 29.7849 12.7085 30 12.167 30C11.6255 30 11.1062 29.7849 10.7233 29.402C10.3404 29.0191 10.1253 28.4998 10.1253 27.9583V24.978ZM8.37533 7.54167V11.0417H4.87533C4.72062 11.0417 4.57224 10.9802 4.46285 10.8708C4.35345 10.7614 4.29199 10.613 4.29199 10.4583V7.54167C4.29199 7.00018 4.5071 6.48088 4.88998 6.09799C5.27287 5.7151 5.79217 5.5 6.33366 5.5C6.87514 5.5 7.39445 5.7151 7.77734 6.09799C8.16022 6.48088 8.37533 7.00018 8.37533 7.54167ZM29.667 30H15.3621C15.7486 29.395 15.9587 28.6875 15.9587 27.9583V26.5C15.9587 26.3453 16.0201 26.1969 16.1295 26.0875C16.2389 25.9781 16.3873 25.9167 16.542 25.9167H31.1253C31.28 25.9167 31.4284 25.9781 31.5378 26.0875C31.6472 26.1969 31.7087 26.3453 31.7087 26.5V27.9583C31.7087 28.4998 31.4936 29.0191 31.1107 29.402C30.7278 29.7849 30.2085 30 29.667 30Z"
                  fill="#FF0083"
                />
              </svg>
              <p className="lastcardhead">Read Whitepaper</p>
            </Link>
            <Link to='/roadmap' className="lastcard animate">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
              >
                <path
                  d="M21.0713 8.3481C21.4761 8.55039 21.9224 8.65571 22.375 8.65571C22.8276 8.65571 23.2739 8.55039 23.6788 8.3481L29.0148 5.67935C29.2373 5.56816 29.4845 5.51574 29.733 5.52705C29.9815 5.53837 30.2229 5.61305 30.4344 5.744C30.6459 5.87494 30.8204 6.05781 30.9412 6.2752C31.0621 6.49259 31.1254 6.73728 31.125 6.98601V25.6002C31.1249 25.8709 31.0493 26.1363 30.9069 26.3666C30.7645 26.5968 30.5607 26.7829 30.3185 26.9039L23.6788 30.2246C23.2739 30.4269 22.8276 30.5322 22.375 30.5322C21.9224 30.5322 21.4761 30.4269 21.0713 30.2246L14.9288 27.1533C14.5239 26.951 14.0776 26.8457 13.625 26.8457C13.1724 26.8457 12.7261 26.951 12.3213 27.1533L6.98521 29.8221C6.7626 29.9333 6.51523 29.9857 6.26663 29.9743C6.01803 29.963 5.77648 29.8881 5.56497 29.757C5.35345 29.6259 5.17901 29.4428 5.05824 29.2252C4.93747 29.0077 4.87439 28.7628 4.875 28.5139V9.90122C4.87515 9.63047 4.95067 9.36509 5.0931 9.13483C5.23554 8.90457 5.43926 8.7185 5.68146 8.59747L12.3213 5.27685C12.7261 5.07455 13.1724 4.96924 13.625 4.96924C14.0776 4.96924 14.5239 5.07455 14.9288 5.27685L21.0713 8.3481Z"
                  stroke="#FF0083"
                  stroke-width="1.75"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.5 4.96924C14.5 4.48599 14.1082 4.09424 13.625 4.09424C13.1418 4.09424 12.75 4.48599 12.75 4.96924V18.5713L14.5 17.5609V4.96924ZM14.5 20.8491L12.75 21.8595V26.8442C12.75 27.3275 13.1418 27.7192 13.625 27.7192C14.1082 27.7192 14.5 27.3275 14.5 26.8442V20.8491Z"
                  fill="#FF0083"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23.25 8.65576C23.25 8.17251 22.8582 7.78076 22.375 7.78076C21.8918 7.78076 21.5 8.17251 21.5 8.65576V13.5195L23.25 12.5091V8.65576ZM23.25 15.7973L21.5 16.8077V30.5308C21.5 31.014 21.8918 31.4058 22.375 31.4058C22.8582 31.4058 23.25 31.014 23.25 30.5308V15.7973Z"
                  fill="#FF0083"
                />
              </svg>
              <p className="lastcardhead">View the Roadmap</p>
            </Link>
            <a href="https://app.gitbook.com/o/RIfIxkQbOtQ1iU7sTzvt/s/NsQmzdiXTPQUCff2LZ6d/" target="_blank">
              <div className="lastcard animate">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="36"
                  viewBox="0 0 35 36"
                  fill="none"
                >
                  <path
                    d="M13.2563 13.3751C13.5992 12.4004 14.2759 11.5786 15.1667 11.0551C16.0575 10.5316 17.1047 10.3402 18.1231 10.5149C19.1414 10.6896 20.065 11.219 20.7304 12.0094C21.3958 12.7998 21.76 13.8002 21.7584 14.8334C21.7584 17.7501 17.3834 19.2084 17.3834 19.2084"
                    stroke="#FF0083"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.5 25.0417H17.5146"
                    stroke="#FF0083"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.6002 3.78095C15.2736 3.52143 11.9636 4.4586 9.26682 6.42358C9.13854 6.51704 9.01206 6.61254 8.8874 6.71002L10.1467 7.94949C10.1966 7.91195 10.2468 7.87477 10.2974 7.83795C12.6571 6.11859 15.5533 5.29857 18.4641 5.52565C21.3749 5.75273 24.1089 7.01199 26.1734 9.07649C28.2379 11.141 29.4971 13.875 29.7242 16.7858C29.9511 19.6941 29.1326 22.5879 27.4162 24.9465L28.6755 26.186C28.7264 26.1189 28.7766 26.0512 28.8263 25.983C30.7913 23.2862 31.7284 19.9763 31.4689 16.6497C31.2094 13.323 29.7702 10.1985 27.4108 7.83905C25.0514 5.47962 21.9268 4.04048 18.6002 3.78095ZM26.7344 28.2711L25.4833 27.0397C24.0137 28.2992 22.2557 29.2017 20.3466 29.6559C17.5062 30.3317 14.5179 29.9707 11.9201 28.6381C11.7094 28.5301 11.464 28.512 11.2398 28.588L4.31423 30.9356L6.66188 24.0101C6.73788 23.7859 6.71979 23.5404 6.61174 23.3298C5.27913 20.732 4.91818 17.7437 5.59393 14.9033C6.0329 13.0582 6.89059 11.3543 8.08462 9.91548L6.83345 8.68405C5.41905 10.3521 4.40475 12.3407 3.89145 14.4983C3.14815 17.6226 3.50238 20.9035 4.88786 23.7924L2.08785 32.0524C1.98093 32.3678 2.06232 32.7166 2.29781 32.952C2.53329 33.1875 2.88204 33.2689 3.19744 33.162L11.4575 30.362C14.3464 31.7475 17.6273 32.1017 20.7516 31.3584C22.9824 30.8277 25.0325 29.7614 26.7344 28.2711Z"
                    fill="#FF0083"
                  />
                </svg>
                <p className="lastcardhead">Get Support</p>
              </div>
            </a>
          </div>
          {/* <div className="lastcard">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
              >
                <path
                  d="M21.0713 8.3481C21.4761 8.55039 21.9224 8.65571 22.375 8.65571C22.8276 8.65571 23.2739 8.55039 23.6788 8.3481L29.0148 5.67935C29.2373 5.56816 29.4845 5.51574 29.733 5.52705C29.9815 5.53837 30.2229 5.61305 30.4344 5.744C30.6459 5.87494 30.8204 6.05781 30.9412 6.2752C31.0621 6.49259 31.1254 6.73728 31.125 6.98601V25.6002C31.1249 25.8709 31.0493 26.1363 30.9069 26.3666C30.7645 26.5968 30.5607 26.7829 30.3185 26.9039L23.6788 30.2246C23.2739 30.4269 22.8276 30.5322 22.375 30.5322C21.9224 30.5322 21.4761 30.4269 21.0713 30.2246L14.9288 27.1533C14.5239 26.951 14.0776 26.8457 13.625 26.8457C13.1724 26.8457 12.7261 26.951 12.3213 27.1533L6.98521 29.8221C6.7626 29.9333 6.51523 29.9857 6.26663 29.9743C6.01803 29.963 5.77648 29.8881 5.56497 29.757C5.35345 29.6259 5.17901 29.4428 5.05824 29.2252C4.93747 29.0077 4.87439 28.7628 4.875 28.5139V9.90122C4.87515 9.63047 4.95067 9.36509 5.0931 9.13483C5.23554 8.90457 5.43926 8.7185 5.68146 8.59747L12.3213 5.27685C12.7261 5.07455 13.1724 4.96924 13.625 4.96924C14.0776 4.96924 14.5239 5.07455 14.9288 5.27685L21.0713 8.3481Z"
                  stroke="#FF0083"
                  stroke-width="1.75"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.5 4.96924C14.5 4.48599 14.1082 4.09424 13.625 4.09424C13.1418 4.09424 12.75 4.48599 12.75 4.96924V18.5713L14.5 17.5609V4.96924ZM14.5 20.8491L12.75 21.8595V26.8442C12.75 27.3275 13.1418 27.7192 13.625 27.7192C14.1082 27.7192 14.5 27.3275 14.5 26.8442V20.8491Z"
                  fill="#FF0083"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23.25 8.65576C23.25 8.17251 22.8582 7.78076 22.375 7.78076C21.8918 7.78076 21.5 8.17251 21.5 8.65576V13.5195L23.25 12.5091V8.65576ZM23.25 15.7973L21.5 16.8077V30.5308C21.5 31.014 21.8918 31.4058 22.375 31.4058C22.8582 31.4058 23.25 31.014 23.25 30.5308V15.7973Z"
                  fill="#FF0083"
                />
              </svg>
              <h6 className="lastcardhead">View the Roadmap</h6>
            </div>
            <div className="lastcard">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="36"
                viewBox="0 0 35 36"
                fill="none"
              >
                <path
                  d="M13.2563 13.3751C13.5992 12.4004 14.2759 11.5786 15.1667 11.0551C16.0575 10.5316 17.1047 10.3402 18.1231 10.5149C19.1414 10.6896 20.065 11.219 20.7304 12.0094C21.3958 12.7998 21.76 13.8002 21.7584 14.8334C21.7584 17.7501 17.3834 19.2084 17.3834 19.2084"
                  stroke="#FF0083"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.5 25.0417H17.5146"
                  stroke="#FF0083"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.6002 3.78095C15.2736 3.52143 11.9636 4.4586 9.26682 6.42358C9.13854 6.51704 9.01206 6.61254 8.8874 6.71002L10.1467 7.94949C10.1966 7.91195 10.2468 7.87477 10.2974 7.83795C12.6571 6.11859 15.5533 5.29857 18.4641 5.52565C21.3749 5.75273 24.1089 7.01199 26.1734 9.07649C28.2379 11.141 29.4971 13.875 29.7242 16.7858C29.9511 19.6941 29.1326 22.5879 27.4162 24.9465L28.6755 26.186C28.7264 26.1189 28.7766 26.0512 28.8263 25.983C30.7913 23.2862 31.7284 19.9763 31.4689 16.6497C31.2094 13.323 29.7702 10.1985 27.4108 7.83905C25.0514 5.47962 21.9268 4.04048 18.6002 3.78095ZM26.7344 28.2711L25.4833 27.0397C24.0137 28.2992 22.2557 29.2017 20.3466 29.6559C17.5062 30.3317 14.5179 29.9707 11.9201 28.6381C11.7094 28.5301 11.464 28.512 11.2398 28.588L4.31423 30.9356L6.66188 24.0101C6.73788 23.7859 6.71979 23.5404 6.61174 23.3298C5.27913 20.732 4.91818 17.7437 5.59393 14.9033C6.0329 13.0582 6.89059 11.3543 8.08462 9.91548L6.83345 8.68405C5.41905 10.3521 4.40475 12.3407 3.89145 14.4983C3.14815 17.6226 3.50238 20.9035 4.88786 23.7924L2.08785 32.0524C1.98093 32.3678 2.06232 32.7166 2.29781 32.952C2.53329 33.1875 2.88204 33.2689 3.19744 33.162L11.4575 30.362C14.3464 31.7475 17.6273 32.1017 20.7516 31.3584C22.9824 30.8277 25.0325 29.7614 26.7344 28.2711Z"
                  fill="#FF0083"
                />
              </svg>
              <h6 className="lastcardhead">Get Support</h6>
            </div> */}
        </div>
        {/* </div> */}
      </section>
    </>
  );
};

export default Evolve;
